<template>
  <div class="content">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <el-alert :closable="false" title="此页面操作的状态都是修改运营商的真实状态，请谨慎操作。" type="info" show-icon></el-alert>
      </div>
      <div style="margin-left:30px">
        <div style="font-size: 14px;text-align: left;">1、按选择的类型填入对应的ICCID或者MSISDN；</div>
        <div style="font-size: 14px;text-align: left;">2、选择文件上传时，先下载模板，按模板格式填写；</div>
        <div style="font-size: 14px;text-align: left;"> 3、数据的最大条数2000条；</div>
        <div style="font-size: 14px;text-align: left;"> 4、开网断网指的是开停GPRS；</div>
        <div style="font-size: 14px;text-align: left;"> 5、批量操作需要一定时间，提交后到任务中心查询处理进度；</div>
      </div>
    </el-card>
    <el-card class="box-card">
      <el-form :model="ruleForm" :inline="false" ref="ruleForm" label-width="150px"  :rules="rules">
        <el-row>
          <el-col :span="12">
            <el-form-item label="类型" prop="fieldType" >
              <el-radio v-model="ruleForm.fieldType" label="1" >ICCID</el-radio>
              <el-radio v-model="ruleForm.fieldType" label="2" >MSISDN</el-radio>
              <el-radio v-model="ruleForm.fieldType" label="3" >文件上传</el-radio>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="运营商状态" prop="status" >
              <el-radio v-model="ruleForm.status" label="1" >开机</el-radio>
              <el-radio v-model="ruleForm.status" label="2" >停机</el-radio>
              <el-radio v-model="ruleForm.status" label="3" >开网</el-radio>
              <el-radio v-model="ruleForm.status" label="4" >断网</el-radio>
              <el-radio v-model="ruleForm.status" label="5" >开同步</el-radio>
              <el-radio v-model="ruleForm.status" label="6" >关同步</el-radio>
            </el-form-item>
          </el-col>
        </el-row>    
        <el-row v-if="ruleForm.fieldType != '3'">
          <el-col :span="12">
            <el-form-item label="卡号范围" >
              <el-row>
                <el-col :span="11">
                  <el-form-item prop="iccidStart">
                    <el-input
                      v-model="ruleForm.iccidStart"
                      clearable
                      placeholder="包含开始值"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col style="text-align: center;" :span="2">-</el-col>
                <el-col :span="11">
                  <el-form-item prop="iccidEnd">
                    <el-input
                      v-model="ruleForm.iccidEnd"
                      clearable
                      placeholder="包含终止值"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>    
        <el-row v-if="ruleForm.fieldType != '3'">
          <el-col :span="12">
            <el-form-item label="卡号列表" prop="iccids">
              <el-input v-model="ruleForm.iccids" type="textarea" placeholder="请输入批量卡号，每行只能输入一张卡号" rows="8" @input="handleCount">
              </el-input>
              <div><span>选中<em style="color:red">{{iccidCount}}</em>条</span></div>
            </el-form-item>
          </el-col>
        </el-row>   
        <el-row v-if="ruleForm.fieldType == '3'">
          <el-col :span="12">
            <el-form-item label="Excel文件：" prop="file" >
              <el-upload
                ref="upload"
                :limit="1"
                accept=".xlsx, .xls"
                action
                :auto-upload="true"
                :http-request="httpRequest"
                drag
              >
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip text-center" style="text-align: left;" slot="tip">
                  <span>仅允许导入xls、xlsx格式文件。</span>
                  <el-link type="primary" :underline="false" style="font-size:12px;vertical-align: baseline;" @click="importTemplate">下载模板</el-link>
                </div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>    
        <el-form-item>
          <el-button type="primary" size="medium" @click="submitForm('ruleForm')" >提交</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>
<script>
import { batchUpdateCarrierStatus } from "@/api/api.js"; //流量卡列表
export default {
  name:'carrierStatus',
  data() {
    return {
      ruleForm: {
        fieldType:"1",
        status:"1",
        iccidStart:"",
        iccidEnd:"",
        iccids:"",
      },
      iccidCount:0,
      submitLoading:false,
      // 表单验证
			rules:{
				file: [
          { required: true,validator: this.checkFile, trigger: "blur" }
				],
			},
      fileList: []
    };
  },
  computed: {
    cardIccids(){
      return this.$store.state.card.iccids;
    },
  },
  watch: {
    cardIccids(){
      this.handleIccids()
    }
  },
  methods: {
    handleIccids(){
      if(this.cardIccids){
        let arrIccids = this.cardIccids.split(",");
        this.ruleForm.iccids = arrIccids.join("\n");
        this.fieldType = "1";
        this.iccidCount = arrIccids.length;
      }else{
        this.ruleForm.iccids ='';
        this.iccidCount =0;
      }
    },
    httpRequest(param) {
      this.ruleForm.file = param.file;
    },
    checkFile(rule, value, callback){
      if (!value) {
        return callback(new Error('请上传EXCEL文件'));
      }else{
        callback();
      }
    },
    handleCount(){
      let iccids = this.ruleForm.iccids || "";
      let arr = iccids.split("\n").filter(v=>!!v);
      this.iccidCount = arr.length;
    },
    submitForm() {
      this.$refs.ruleForm.validate(valid => {
        if(valid){
          let config = {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          };
          let formData = new FormData();
          formData.append("file", this.ruleForm.file);
          formData.append("fieldType", this.ruleForm.fieldType);
          formData.append("status", this.ruleForm.status);
          formData.append("iccidStart", this.ruleForm.iccidStart);
          formData.append("iccidEnd", this.ruleForm.iccidEnd);
          formData.append("iccids", this.ruleForm.iccids);
          batchUpdateCarrierStatus(formData, config).then(res => {
              this.$notify({
                title: "提示",
                message: "已提交卡导入，请在任务中心查看进度",
                type: "success",
                offset:30
              });
              this.resetForm("ruleForm");
              this.$store.dispatch('ClearIccids')
              this.$refs.upload && this.$refs.upload.clearFiles()
              setTimeout(()=>{
                this.$router.push({ path: `/taskCenter/missionList`});
              },1000)
          })
        }
      })
    },
    /**下载模板操作 */
    importTemplate() {
      this.download('/card/updateCardStatusTemplate', {
      }, `Template_${new Date().getTime()}.xlsx`)
    },
  },
  created() {
    this.handleIccids()
  },
  mounted() {

  }
};
</script>
<style lang="less" scoped>

</style>
